import React from 'react'
import styled from 'styled-components'
import {getBorder, getThemeColor} from 'utils'
import convertUnit from 'lib/unit'

const StyledMarker = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${convertUnit(37)};
  height: ${convertUnit(37)};
`

const StyledOuterCircle = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  filter: blur(1.5px);
  background-color: ${({theme}) => getThemeColor(theme, 'primary_5', 0.4)};
`

const StyledInnerCircle = styled.div`
  border-radius: 50%;
  width: ${convertUnit(12)};
  height: ${convertUnit(12)};
  border: ${({theme}) => getBorder(1.5, 'solid', theme.white_1)};
  background-color: ${({theme}) => theme.primary_5};
  z-index: 1;
`

export default function TreeSelfMarker() {
  return (
    <StyledMarker>
      <StyledOuterCircle aria-hidden="true" />
      <StyledInnerCircle />
    </StyledMarker>
  )
}
